import { InputModule } from './../input/input.module';
import { IconModule } from './../icon/icon.module';
import { StatusModule } from "../status/status.module";
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DatepickerComponent } from "./datepicker.component";
import { DatepickerInputComponent } from "./datepicker-input/datepicker-input.component";

import { FormsModule } from "@angular/forms";
import { DatepickerDayComponent } from "./datepicker-day/datepicker-day.component";
import { DatepickerMonthComponent } from "./datepicker-month/datepicker-month.component";
import { DatepickerYearComponent } from "./datepicker-year/datepicker-year.component";
import * as language from "./locale";

@NgModule({
	declarations: [
		DatepickerComponent,
		DatepickerInputComponent,
		DatepickerDayComponent,
		DatepickerMonthComponent,
		DatepickerYearComponent
	],
	imports: [CommonModule, FormsModule, HelpTextModule, LabelModule, StatusModule, IconModule, InputModule],
	exports: [
		DatepickerComponent,
		DatepickerInputComponent,
		DatepickerDayComponent,
		DatepickerMonthComponent,
		DatepickerYearComponent
	]
})
export class DatepickerModule { }
